import Conf from './Conf'
import Dot from './Dot'
import Markup from './Markup'
import State from './State'
import Storage from './Storage'

let currentLang = null
let translations = {}
let moment = null

export default class I18n {
  static async init() {
    const conf = Conf.get().i18n
    const forceLanguage = await Storage.get('lang', null)

    let userLang = (navigator.language || navigator.userLanguage).split('-')[0].toLowerCase()
    if (conf.languages.includes(userLang) === false) {
      userLang = conf.default
    }

    if (forceLanguage !== null && conf.languages.includes(forceLanguage)) {
      userLang = forceLanguage
    }

    if (Conf.get().lang !== null && conf.languages.includes(Conf.get().lang)) {
      userLang = Conf.get().lang
    }

    currentLang = userLang
    await Storage.set('lang', userLang)
  }

  static async loadTranslations() {
    const { default: translationList } = await import(/* webpackChunkName: "i18n-data" */ '../langs/' + currentLang + '.js')
    const { default: momentObj } = await import(/* webpackChunkName: "i18n-data" */ 'moment')
    moment = momentObj
    moment.locale(currentLang)
    translations = translationList
  }

  static defaultLocale() {
    return Conf.get().i18n.default
  }

  static locale() {
    return currentLang
  }

  static moment(date = undefined) {
    return moment(date)
  }

  static $t(text, markdown = true, markdown2 = true) {
    if (text === undefined || Object.keys(text ?? {}).length === 0) {
      return ''
    }

    let replacements = {}
    if (typeof markdown === 'object') {
      replacements = markdown
      markdown = markdown2
    }

    let finalString = ''
    if (typeof text === 'string') {
      if (translations[text] === undefined) {
        finalString = text
      } else {
        finalString = translations[text]
      }
    } else if (text[currentLang] !== undefined) {
      finalString = text[currentLang]
    } else if (text[Conf.get().i18n.default] !== undefined) {
      finalString = text[Conf.get().i18n.default]
    } else {
      finalString = text[Object.keys(text)[0]]
    }

    for (let key in replacements) {
      finalString = finalString.replace(`{{${key}}}`, replacements[key])
    }

    finalString = finalString.replace(
      /{{(values|replies|apicall|lang)\.?([a-zA-Z0-9\-_]+)?(\.([0-9]+))?(\:([a-z0-9\.\-_]+))?(\|[a-z]+)?}}/gi,
      (match, type, key, _, idx, __, query, transformers, offset, string) => {
        let val = null
        switch (type) {
          case 'values':
            const values = Conf.get().values ?? {}
            if (values[key] !== undefined)
              val = values[key]
            break;
          case 'lang':
            val = currentLang
            break;
          case 'apicall':
            const apicalls = State.getApiCalls()
            if (apicalls[key] !== undefined) {
              if (typeof apicalls[key].result === 'string') {
                val = apicalls[key].result
              } else {
                val = Dot.get(apicalls[key].result, query)
              }
            }
            break;
          case 'replies':
            const replies = State.getReplies()
            val = replies[key] === undefined ? null : replies[key]

            if (val !== null) {
              if (val instanceof Array) {
                val = val.map(v => v.name)
              } else {
                val = val.name
              }
            }
            break;
        }

        if (idx !== undefined) {
          if (val instanceof Array && val[+idx] !== undefined) {
            val = val[+idx]
          } else {
            val = null
          }
        }

        if (val === null) {
          return match
        }

        if (val instanceof Array) {
          val = val.join(', ')
        }

        if (transformers !== undefined) {
          transformers = transformers.split('|')

          for (const func of transformers) {
            switch (func) {
              case 'uppercase':
                val = val.toUpperCase()
                break
              case 'lowercase':
                val = val.toLowerCase()
                break
              case 'ucfirst':
                val = val.toLowerCase()
                val = val.charAt(0).toUpperCase() + val.slice(1)
                break
            }
          }
        }
        return val
      }
    )

    return markdown ? Markup.format(finalString) : finalString
  }
}
